import React from 'react';
import { Radio, Select } from 'antd';
import { useSelector } from 'react-redux';

const UserEmployeAssets = () => {

  const employeeDetails = useSelector((state: any) => state?.employee?.employeeDetails);
  const assetConfig = [
    { "label": "Basic", value: 'Basic' },
    { "label": "Intermediate", value: 'Intermediate' },
    { "label": "Advanced", value: 'Advanced' }
  ]
  const assetType = [
    { "label": "Laptop", value: 'Laptop' },
    { "label": "Desktop", value: 'Desktop' },
  ];

  return (
    <div className='salary_details font-rubik'>
      <div className="employee-assets  mt-5">
        <div className="configuration-section mb-8 2xl:p-6 p-4 bg-white rounded-lg border border-gray-200 shadow-sm">
          <h3 className="text-lg font-semibold text-gray-800 mb-6 pb-2 border-b border-gray-200">Configuration Details</h3>

          <div className="flex flex-col space-y-6">
            <div className="flex items-center box">
              <div className="w-48 flex-shrink-0">
                <label className='font-rubik text-gray-700 font-medium'>Configuration Type</label>
              </div>
              <div className="flex-1 user-inputs-disabled">
                <Select
                  disabled={true}
                  className='font-rubik w-full max-w-xs !cursor-not-allowed'
                  value={employeeDetails?.employeeAssertInfo?.assertType !== null ? employeeDetails?.employeeAssertInfo?.assertType : 'Basic'}
                  options={assetConfig.map(option => ({ label: option.label, value: option.value }))}
                />
              </div>
            </div>


            {employeeDetails?.employeeAssertInfo && (
              <div className="bg-gray-50 rounded-md p-4">
                <div className="grid grid-cols-2 sm:grid-cols-3 gap-6">
                  <div className="space-y-1">
                    <label className='font-rubik text-xs sm:text-sm text-gray-500 uppercase tracking-wider'>
                      Processor
                    </label>

                    <p className='font-rubik text-gray-800 font-medium'>
                      {employeeDetails?.employeeAssertInfo?.processor || '-'}
                    </p>
                  </div>


                  <div className="space-y-1">
                    <label className='font-rubik text-xs sm:text-sm text-gray-500 uppercase tracking-wider'>RAM</label>
                    <p className='font-rubik text-gray-800 font-medium'>
                      {employeeDetails?.employeeAssertInfo?.ram || '-'}
                    </p>
                  </div>

                  <div className="space-y-1">
                    <label className='font-rubik text-xs sm:text-sm text-gray-500 uppercase tracking-wider'>SSD</label>
                    <p className='font-rubik text-gray-800 font-medium'>
                      {employeeDetails?.employeeAssertInfo?.ssd || '-'}
                    </p>
                  </div>
                  <div className="space-y-1">
                    <label className='font-rubik text-xs sm:text-sm text-gray-500 uppercase tracking-wider'>Graphics Card</label>
                    <p className='font-rubik text-gray-800 font-medium'>
                      {employeeDetails?.employeeAssertInfo?.graphicCard || '-'}
                    </p>
                  </div>
                  <div className="space-y-1">
                    <label className='font-rubik text-xs sm:text-sm text-gray-500 uppercase tracking-wider'>OS</label>
                    <p className='font-rubik text-gray-800 font-medium'>
                      {employeeDetails?.employeeAssertInfo?.os || '-'}
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="device-section device-type-box p-6 bg-white rounded-lg border border-gray-200 shadow-sm mb-8">
          <h3 className="text-lg font-semibold text-gray-800 mb-6 pb-2 border-b border-gray-200">Device Information</h3>

          <div className="space-y-6">

            <div className="flex items-center ">
              <div className="w-48 flex-shrink-0 label-box">
                <label className='font-rubik text-gray-700 font-medium'>Device Type</label>
              </div>
              <div className="flex-1">
                <Radio.Group
                  className='font-rubik'
                  name="deviceType"
                  disabled={true}
                  value={employeeDetails?.deviceType !== null ? employeeDetails?.deviceType : 'Laptop'}
                  options={assetType}
                />
              </div>
            </div>


            <div className="flex items-center">
              <div className="w-48 flex-shrink-0 label-box">
                <label className='font-rubik text-gray-700 font-medium'>Other Peripherals</label>
              </div>
              <div className="flex-1">
                <p className='font-rubik text-gray-800 font-medium'>
                  {employeeDetails?.otherPeripherals !== "" ? employeeDetails?.otherPeripherals : 'N/A'}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div >
  )
}

export default UserEmployeAssets
